import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Pedido extends Component {
    constructor(props){
        super(props);
   
        this.state = {
            pedido: [],
            productos: [],
            confirmacion: []
        }
   
   fetch('https://ebenlovequickpc.com/API/pedidos.php?cl=one&factura='+props.match.params.id)
       .then((response => response.json()))
       .then((json) => {
            fetch('https://ebenlovequickpc.com/API/confirmacion.php?cl=select&user='+json[0].CODIGO_USER+'&fact='+props.match.params.id)
            .then((response => response.json()))
            .then((json) => {
                this.setState({
                    confirmacion: json
                });
            });
           this.setState({
               pedido: json
           });
       });
       
    }
    productList(list){
        
    }
    aprobar(){
        fetch('https://ebenlovequickpc.com/API/aprobacion.php?cl=update&user='+this.state.pedido[0].CODIGO_USER+'&conf='+this.state.confirmacion[0].CODIGO+'&fact='+this.props.match.params.id)
            .then((response => response.json()))
            .then((json) => {
                if (!("Notification" in window)) {
                    alert("This browser does not support desktop notification");
                  }else if (Notification.permission === "granted") {
                    
                    var notification = new Notification("COMPLETADO");
                  }else if (Notification.permission !== 'denied') {
                    Notification.requestPermission(function (permission) {
                      if (permission === "granted") {
                        var notification = new Notification("COMPLETADO");
                      }
                    });
                  }
                  window.location.href = `/pedidos`;
            });
    }
    rechazar(){}
  render() {
    return (
        <div className="w3-container">
        { this.state.pedido.map((v, i) => {
            this.productList(v.CODIGO_CAR);
            return (
            <div className="w3-panel" key={i}>
                <div className="w3-row-padding" style={{margin:'0 -16px'}}>
                    <div className="w3-third">
                        <h3>Productos</h3>
                        <div className="w3-white w3-text-grey w3-card-4">
                        <ul className="w3-ul w3-card-4 w3-white">
                            <li className="w3-display-container" >0 <Link to={``} className="w3-button w3-display-right">Ver</Link></li>
                        </ul>
                        </div>
                        <h3>Comprobante</h3>
                        <div className="w3-white w3-text-grey w3-card-4">
                            { this.state.confirmacion.map((v, i) => {
                                return (
                                    <div className="w3-container">
                                        { v.TIPO == 'banco' &&
                                            <div>
                                                <p><strong>Orden</strong></p>
                                                <p>{v.ORDEN}</p>
                                                <p><strong>Fecha</strong></p>
                                                <p>{v.FECHA} {v.HORA}</p>
                                                <p><strong>Banco</strong></p>
                                                <p>{v.BANCO}</p>
                                                <p><strong>Sucursal</strong></p>
                                                <p>{v.SUCURSAL}</p>
                                                <p><strong>No. de recibo</strong></p>
                                                <p>{v.RECIBO}</p>
                                                <p><strong>Monto</strong></p>
                                                <p>{v.MONTO}</p>
                                            </div>
                                        }
                                        { v.TIPO == 'envios' &&
                                            <div>
                                                <p><strong>Orden</strong></p>
                                                <p>{v.ORDEN}</p>
                                                <p><strong>Fecha</strong></p>
                                                <p>{v.FECHA} {v.HORA}</p>
                                                <p><strong>Envio</strong></p>
                                                <p>{v.ENVIO}</p>
                                                <p><strong>Remitente</strong></p>
                                                <p>{v.REMITENTE}</p>
                                                <p><strong>Destinatario</strong></p>
                                                <p>{v.DESTINATARIO}</p>
                                                <p><strong>No. de recibo</strong></p>
                                                <p>{v.RECIBO}</p>
                                                <p><strong>Monto</strong></p>
                                                <p>{v.MONTO}</p>
                                            </div>
                                        }
                                        { v.TIPO == 'agente' &&
                                            <div>
                                                <p><strong>Orden</strong></p>
                                                <p>{v.ORDEN}</p>
                                                <p><strong>Fecha</strong></p>
                                                <p>{v.FECHA} {v.HORA}</p>
                                                <p><strong>Cliente</strong></p>
                                                <p>{v.CLIENTE}</p>
                                                <p><strong>Agente</strong></p>
                                                <p>{v.AGENTE}</p>
                                                <p><strong>No. de recibo</strong></p>
                                                <p>{v.RECIBO}</p>
                                                <p><strong>Monto</strong></p>
                                                <p>{v.MONTO}</p>
                                            </div>
                                        }
                                </div>
                                )
                            })}
                            { this.state.confirmacion.length == 0 && 
                                <div className="w3-container">
                                    <h4>Aun cliente no comprueba su factura</h4>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="w3-twothird">
                        <div className="w3-container w3-card w3-white">
                            <ul className="w3-ul">
                                <li className="w3-padding-16 w3-display-container">
                                    <img src="https://www.w3schools.com/w3images/avatar2.png" alt='' className="w3-left w3-circle w3-margin-right" style={{width:'35px'}} />
                                    <span className="w3-xlarge">{v.NOMBRE} {v.APELLIDOS}</span>
                                    <Link to={`/clientes/${v.CODIGO_USER}`} className="w3-button w3-border w3-display-right w3-round-large" style={{marginRight: '7px'}}>Ver</Link>
                                </li>
                            </ul>
                            <div className="w3-container">
                                <p><strong>Metodo de pago</strong></p>
                                <p>{v.METODO_PAGO}</p>
                                <p><strong>Metodo de compra</strong></p>
                                <p>{v.METODO_COMPRA}</p>
                                <p><strong>Zona de envío</strong></p>
                                <p>{v.ZONA_ENVIO}</p>
                                <hr />
                            </div>
                            { this.state.confirmacion.length > 0 && 
                                <div className='w3-center'>
                                    <button className="w3-button w3-margin-right w3-border w3-border-green w3-round-large" onClick={this.aprobar.bind(this)}>Aprobar</button>
                                    <button className="w3-button w3-margin-left w3-border w3-border-red w3-round-large" onClick={this.rechazar.bind(this)}>Rechazar</button>
                                    <br />
                                    <br />
                                </div>
                            }
                            { this.state.confirmacion.length == 0 && 
                                <div className='w3-center'>
                                    <Link to={`/pedidos`} className="w3-button w3-margin-left w3-border w3-border-red w3-round-large">Atras</Link>
                                    <br />
                                    <br />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            )
        }) }
      </div>
    );
  }
}

export default Pedido;


// WEBPACK FOOTER //
// ./src/Pedidos/Pedido.js